module.exports = __webpack_public_path__ + "img/EyebrowTrimmers.3834b8b2.png";